(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  const drawer = document.querySelector('[data-iona-cart-drawer]');
  if (!drawer) return;
  const backdrop = drawer.querySelector('[data-cart-backdrop]');
  const closeBtn = drawer.querySelector('[data-cart-close]');
  const body = drawer.querySelector('[data-cart-body]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const countEl = drawer.querySelector('[data-cart-item-count]');
  const labelEl = drawer.querySelector('[data-cart-item-label]');

  const moneyFormatString = drawer.dataset.moneyFormat || '${{amount}}';
  function moneyFormat(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormatString.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Header cart link + any opener
  document.querySelectorAll('[data-iona-cart-link], [data-iona-cart-open]').forEach((el) => {
    el.addEventListener('click', (e) => { e.preventDefault(); refresh().then(open); });
  });
  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  async function refresh() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!r.ok) return;
      const cart = await r.json();
      render(cart);
    } catch (e) {}
  }

  function render(cart) {
    countEl.textContent = cart.item_count;
    labelEl.textContent = cart.item_count === 1 ? 'item' : 'items';
    subtotalEl.textContent = moneyFormat(cart.total_price);
    footer.classList.toggle('hidden', cart.item_count === 0);

    if (cart.item_count === 0) {
      body.innerHTML = emptyHTML();
      return;
    }
    body.innerHTML = itemsHTML(cart);
    bindItemActions();
  }

  function emptyHTML() {
    return `
      <div class="flex flex-col items-center justify-center h-full gap-4 text-center">
        <div class="w-16 h-16 border border-[rgba(201,168,76,0.2)] rounded-full flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" stroke-width="1.2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        </div>
        <p class="text-[#f9f5ee] text-lg font-serif">Your cart is empty</p>
        <p class="text-iona-muted text-[13px] font-display">Discover our curated collections</p>
        <a href="/collections/all" class="mt-2 bg-white text-iona-bg text-[11px] tracking-[1.5px] uppercase px-8 py-3 hover:bg-iona-cream transition-colors font-display">Shop Now</a>
      </div>`;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function itemsHTML(cart) {
    const rows = cart.items.map((item) => {
      const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
      const lineTotal = moneyFormat(item.final_line_price);
      const variant = item.variant_options && item.variant_options.filter((v) => v && v !== 'Default Title').join(' / ');
      return `
        <div class="flex gap-4" data-line-key="${escapeHtml(item.key)}">
          <a href="${escapeHtml(item.url)}" class="w-20 h-20 bg-[#1c1c1a] shrink-0 overflow-hidden block">
            <img src="${escapeHtml(img)}" alt="${escapeHtml(item.product_title)}" class="w-full h-full object-cover" loading="lazy">
          </a>
          <div class="flex-1 min-w-0">
            <p class="text-iona-muted text-[9px] tracking-[2px] uppercase mb-1 font-display">${escapeHtml(item.product_type || '')}</p>
            <a href="${escapeHtml(item.url)}" class="block text-[#f9f5ee] text-[14px] truncate font-serif">${escapeHtml(item.product_title)}</a>
            ${variant ? `<p class="text-iona-muted text-[11px] mt-0.5 font-display">${escapeHtml(variant)}</p>` : ''}
            <div class="flex items-center justify-between mt-3">
              <div class="flex items-center gap-3 border border-[rgba(237,232,222,0.12)]">
                <button type="button" data-line-decr class="text-[rgba(237,232,222,0.5)] hover:text-iona-cream-2 px-2 py-1 transition-colors" aria-label="Decrease">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
                <span class="text-[#f9f5ee] text-[13px] min-w-[16px] text-center font-display" data-line-qty>${item.quantity}</span>
                <button type="button" data-line-incr class="text-[rgba(237,232,222,0.5)] hover:text-iona-cream-2 px-2 py-1 transition-colors" aria-label="Increase">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
              </div>
              <div class="flex items-center gap-3">
                <span class="text-iona-gold text-[15px] font-display">${lineTotal}</span>
                <button type="button" data-line-remove class="text-[rgba(237,232,222,0.3)] hover:text-iona-cream-2 transition-colors" aria-label="Remove">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                </button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');
    return `<div class="flex flex-col gap-6">${rows}</div>`;
  }

  function bindItemActions() {
    body.querySelectorAll('[data-line-key]').forEach((row) => {
      const key = row.dataset.lineKey;
      const qtyEl = row.querySelector('[data-line-qty]');
      row.querySelector('[data-line-decr]').addEventListener('click', () => change(key, Math.max(0, parseInt(qtyEl.textContent, 10) - 1)));
      row.querySelector('[data-line-incr]').addEventListener('click', () => change(key, parseInt(qtyEl.textContent, 10) + 1));
      row.querySelector('[data-line-remove]').addEventListener('click', () => change(key, 0));
    });
  }

  async function change(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) return;
      const cart = await res.json();
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
    } catch (e) {}
  }

  // Open drawer when cart:updated fires from add-to-cart
  document.addEventListener('cart:updated', () => { refresh().then(open); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iona-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__ionaCardActions) return;
  window.__ionaCardActions = true;

  const WISH_KEY = 'iona_wishlist';
  // Stored as an array of objects: { id, url, title, image, price, type }.
  // Older builds stored a plain array of id strings — migrate those on read.
  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.map((it) => (typeof it === 'string' ? { id: it } : it)).filter((it) => it && it.id);
    } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
  }

  // Reflect saved wishlist state on load
  function syncWishlistButtons() {
    const ids = getWishlist().map((it) => String(it.id));
    document.querySelectorAll('[data-wishlist-toggle][data-product-id]').forEach((btn) => {
      const id = String(btn.dataset.productId);
      btn.setAttribute('aria-pressed', ids.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }
  syncWishlistButtons();
  document.addEventListener('wishlist:updated', syncWishlistButtons);

  document.addEventListener('click', async (e) => {
    // Wishlist
    const wish = e.target.closest('[data-wishlist-toggle]');
    if (wish) {
      e.preventDefault();
      const id = wish.dataset.productId;
      if (!id) return;
      let list = getWishlist();
      const idx = list.findIndex((it) => String(it.id) === String(id));
      if (idx === -1) {
        list.push({
          id: String(id),
          url: wish.dataset.wlUrl || '',
          title: wish.dataset.wlTitle || '',
          image: wish.dataset.wlImage || '',
          price: wish.dataset.wlPrice || '',
          type: wish.dataset.wlType || '',
        });
        wish.setAttribute('aria-pressed', 'true');
      } else {
        list.splice(idx, 1);
        wish.setAttribute('aria-pressed', 'false');
      }
      saveWishlist(list);
      return;
    }

    // Quick add to cart
    const add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      const variantId = add.dataset.variantId;
      if (!variantId || add.disabled) return;
      const original = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error('add failed');
        add.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => { add.textContent = original; add.disabled = false; }, 1200);
      } catch (err) {
        add.textContent = 'Error';
        setTimeout(() => { add.textContent = original; add.disabled = false; }, 1500);
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  const drawer = document.querySelector('[data-iona-wishlist-drawer]');
  if (!drawer) return;
  const backdrop = drawer.querySelector('[data-wishlist-backdrop]');
  const closeBtn = drawer.querySelector('[data-wishlist-close]');
  const body = drawer.querySelector('[data-wishlist-body]');
  const countEl = drawer.querySelector('[data-wishlist-item-count]');
  const labelEl = drawer.querySelector('[data-wishlist-item-label]');

  const WISH_KEY = 'iona_wishlist';

  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.map((it) => (typeof it === 'string' ? { id: it } : it)).filter((it) => it && it.id);
    } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-iona-wishlist-link], [data-iona-wishlist-open]').forEach((el) => {
    el.addEventListener('click', (e) => { e.preventDefault(); render(); open(); });
  });
  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function emptyHTML() {
    return `
      <div class="flex flex-col items-center justify-center h-full gap-4 text-center">
        <div class="w-16 h-16 border border-[rgba(201,168,76,0.2)] rounded-full flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" stroke-width="1.2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </div>
        <p class="text-[#f9f5ee] text-lg font-serif">Your wishlist is empty</p>
        <p class="text-iona-muted text-[13px] font-display">Tap the heart on any product to save it here</p>
        <a href="/collections/all" class="mt-2 bg-white text-iona-bg text-[11px] tracking-[1.5px] uppercase px-8 py-3 hover:bg-iona-cream transition-colors font-display">Shop Now</a>
      </div>`;
  }

  function itemsHTML(list) {
    const rows = list.map((item) => {
      const img = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2')
        : '';
      return `
        <div class="flex gap-4" data-wl-row data-wl-id="${escapeHtml(item.id)}">
          <a href="${escapeHtml(item.url || '#')}" class="w-20 h-20 bg-[#1c1c1a] shrink-0 overflow-hidden block">
            ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(item.title)}" class="w-full h-full object-cover" loading="lazy">` : ''}
          </a>
          <div class="flex-1 min-w-0">
            ${item.type ? `<p class="text-iona-muted text-[9px] tracking-[2px] uppercase mb-1 font-display">${escapeHtml(item.type)}</p>` : ''}
            <a href="${escapeHtml(item.url || '#')}" class="block text-[#f9f5ee] text-[14px] truncate font-serif">${escapeHtml(item.title)}</a>
            <div class="flex items-center justify-between mt-3">
              <span class="text-iona-gold text-[15px] font-display">${escapeHtml(item.price || '')}</span>
              <div class="flex items-center gap-3">
                <a href="${escapeHtml(item.url || '#')}" class="text-iona-muted text-[10px] tracking-[1.5px] uppercase hover:text-iona-cream-2 transition-colors font-display">View</a>
                <button type="button" data-wl-remove class="text-[rgba(237,232,222,0.3)] hover:text-iona-cream-2 transition-colors" aria-label="Remove from wishlist">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                </button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');
    return `<div class="flex flex-col gap-6">${rows}</div>`;
  }

  function render() {
    const list = getWishlist();
    countEl.textContent = list.length;
    labelEl.textContent = list.length === 1 ? 'item' : 'items';
    if (list.length === 0) {
      body.innerHTML = emptyHTML();
      return;
    }
    body.innerHTML = itemsHTML(list);
    body.querySelectorAll('[data-wl-row]').forEach((row) => {
      row.querySelector('[data-wl-remove]').addEventListener('click', () => {
        const id = row.dataset.wlId;
        const next = getWishlist().filter((it) => String(it.id) !== String(id));
        saveWishlist(next);
        render();
      });
    });
  }

  // Header count badge — keep in sync on load and whenever the wishlist changes.
  function syncBadge() {
    const n = getWishlist().length;
    document.querySelectorAll('[data-iona-wishlist-count]').forEach((el) => {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
    });
  }
  syncBadge();
  document.addEventListener('wishlist:updated', () => { syncBadge(); if (drawer.classList.contains('is-open')) render(); });
  // Reflect changes made in another tab.
  window.addEventListener('storage', (e) => { if (e.key === WISH_KEY) { syncBadge(); if (drawer.classList.contains('is-open')) render(); } });
})();
  } catch(e) { console.error(e); }
})();

})();
